<template>
  <div class="map-item-wrapper">
    <el-row :gutter="10" align="middle">
      <el-col :span="4">
        <div class="map-thumb-wrapper">
          <el-image
            class="map-thumb"
            :src="mapThumbnailUrl"
          />
        </div>
      </el-col>
      <el-col :span="20">
        <div class="card-wrap">
          <div class="card-title">
            <div class="map-name">
              <el-text>
                {{ map.name }}
              </el-text>
            </div>
            <div class="author-wrap">
              <div class="author-left">
                <el-image
                  :src="authorAvatar"
                  class="round-img"
                  v-if="authorAvatar"
                />
                <el-text size="small" truncated>
                  <a class="username-link" :href="authorUrl" target="_blank">{{
                    authorName
                  }}</a>
                </el-text>
              </div>
              <el-text size="small" truncated>
                <span class="secondary-text">{{ timeAgo }}</span>
              </el-text>
            </div>
          </div>
          <div>
            <el-button circle size="small" v-if="map.added_to_map">
              <i
                class="iconfont icon-a-ziyuan41"
                style="color: #fc4c02"
                v-if="map.added_to_map"
              />
            </el-button>
            <el-button circle size="small" v-else @click="addToEarth">
              <i
                class="iconfont icon-a-ziyuan51"
                style="color: #fc4c02; cursor: pointer"
              />
            </el-button>
            <el-button link @click="toggleLayer" v-if="!isDatahubLayer">
              <el-icon>
                <ArrowDownBold v-if="showLayer" />
                <ArrowRightBold v-else />
              </el-icon>
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-card
      class="box-card"
      v-show="showLayer"
      shadow="never"
      v-if="!isDatahubLayer"
    >
      <div class="text item" v-for="(l, i) in map.layers" :key="i">
        <layer-item
          :vis-id="map.id"
          :layer="l"
          :show-toggle-btn="false"
          :show-search-btn="false"
          :show-refresh-btn="false"
        ></layer-item>
      </div>
    </el-card>
  </div>
</template>
<script>
import * as Visualization from '@/carto-node/models/visualization';
import { getCartoModels } from '@/carto-node/models/CoreModels';
import { authorUrlBy, authorAvatarBy, timeAgoBy, authorNameBy, mapThumbnailUrlBy } from "@/components/utils/map";
import LayerItem from '@/components/maps/LayerItem';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';
import { has } from 'lodash';

const { track } = useTrack();

export default {
  components: {
    LayerItem,
  },
  props: {
    map: Object,
    source: String,
  },
  data() {
    return {
      showLayer: false,
      thumbnailWidth: 144,
      thumbnailHeight: 144,
    };
  },
  methods: {
    toggleLayer() {
      this.showLayer = !this.showLayer;
    },
    //添加地图到球体
    addToEarth() {
      this.$store.dispatch(`${this.source}/addToEarth`, this.map.id);
      this.$EventBus.emit("globalcheckedLayer", this.earthLayer);
      track(
        FunctionIdEnum.globalLayer_layers_addNewLayer,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
          name: this.map.name,
        },
      );
    },
  },
  computed: {
    timeAgo() {
      return timeAgoBy(this.map);
    },

    authorName() {
      return authorNameBy(this.map);
    },

    authorUrl() {
      return authorUrlBy(this.map);
    },

    authorAvatar() {
      return authorAvatarBy(this.map);
    },

    mapThumbnailUrl() {
      return mapThumbnailUrlBy(this.map, this.thumbnailWidth, this.thumbnailHeight);
    },

    earthLayer() {
      const earthLayer = Visualization.convert2EarthLayer(
        this.map,
        getCartoModels(),
        {
          width: this.thumbnailWidth,
          height: this.thumbnailHeight,
        },
      );
      return earthLayer;
    },
    //是否是datahub layer
    isDatahubLayer() {
      return this.map && has(this.map, 'layerServiceInfo');
    },
  },
};
</script>
<style scoped>
.map-item-wrapper {
  border-bottom: 1px solid #ebeef5;
  padding: 8px 0 5px 5px;
}

.map-thumb-wrapper {
  text-align: left;
}

.map-name {
  text-align: left;
}

.el-card {
  border: 1px solid #fc4c02;
  margin-top: 5px;
}
.map-item-wrapper:hover {
  background-color: #f3f6f9;
}
.author-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  line-height: 1.5;
}
.round-img {
  border-radius: 50%;
  width: 12px;
  height: 12px;
  border: 1px solid #eee;
}
.card-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  flex: 1;
  margin-right: 10px;
}
.el-button {
  margin: 0 5px 0 0 !important;
}
.author-left {
  display: flex;
  justify-content: center;
  align-items: center;
  .round-img {
    margin-right: 5px;
  }
}
.secondary-text {
  color: #aaa;
}

.username-link {
  color: #aaa;
  text-decoration: none;
}

</style>

<style lang="scss">
.map-thumb {
  width: 45px;
  height: 45px;
  border-radius: 4px;
  img {
    object-fit: cover;
  }
}
</style>